import { Link, useLocation } from "react-router-dom"
import "./editCategory.css"
import { Publish, Close } from "@material-ui/icons"
import { useSelector, useDispatch } from "react-redux"
import { useState } from "react"
import { serverAPI } from "../../services/apiParams"
import { Snackbar, IconButton } from "@mui/material"
import { getCategories } from "../../redux/apiCalls"
import { onImageUpload } from "../../services/uploadImage"
import { renderErrorMsg } from "../../services/errorsForm"

export default function EditCategory() {
  const [categoryForm, setCategoryForm] = useState()
  const location = useLocation()
  const categoryId = location.pathname.split("/")[2]
  const category = useSelector((state) => {
    return state.category.categories.find((category) => {
      return String(category.id) === categoryId
    })
  })
  const dispatch = useDispatch()
  // upload image
  const [imageUrl, setImageUrl] = useState()
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false)
  const [formErrorMsg, setFormErrorMsg] = useState()

  //updata category information
  const handleChangeForm = (e) => {
    setCategoryForm({
      ...categoryForm,
      [e.target.name]: e.target.value,
    })
  }
  const handleChangeImage = (e) => {
    onImageUpload(e, setSubmitBtnDisabled, setFormErrorMsg, setImageUrl)
  }
  const editCategory = async (e) => {
    e.preventDefault()
    const categoryEdited = { ...categoryForm, image: imageUrl }
    try {
      const res = await serverAPI.post(
        `api/categories/${categoryId}`,
        categoryEdited
      )
      // if updated true display snackbar
      res.data.updated && handleClick()
      setCategoryForm({})
      // update Store.categories after editing category's data
      getCategories(dispatch)
      //reset inputs after submit
      document.getElementById("editCategoryForm").reset()
    } catch (error) {
      console.log(error.response)
    }
  }
  // snackbar when category is updated
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
  }
  const closeSnackbarButton = (
    <IconButton
      size='small'
      aria-label='close'
      color='inherit'
      onClick={handleClose}>
      <Close fontSize='small' color='white' />
    </IconButton>
  )
  return (
    <div className='category'>
      <div className='categoryTitleContainer'>
        <h1 className='categoryTitle'>Edit Category</h1>
        <Link to='/newcategory'>
          <button className='categoryAddButton'>Create</button>
        </Link>
      </div>
      <div className='categoryBottom'>
        <form className='categoryForm'>
          <div className='categoryTopLeft'>
            <form className='addProductForm' id='editCategoryForm'>
              <div className='addProductItem'>
                <label>Name</label>
                <input
                  type='text'
                  placeholder={category.name}
                  name='name'
                  onChange={handleChangeForm}
                />
              </div>
              {renderErrorMsg(formErrorMsg, "name")}
              <div className='addProductItem'>
                <label>Description</label>
                <textarea
                  placeholder={category.description}
                  name='description'
                  onChange={handleChangeForm}
                  rows='4'
                  cols='50'
                />
                {renderErrorMsg(formErrorMsg, "description")}
              </div>
              <button
                className='addProductButton'
                onClick={editCategory}
                disabled={submitBtnDisabled}>
                Edit
              </button>
            </form>
          </div>
          <div className='categoryFormRight'>
            <div className='categoryUpload'>
              <img
                src={category.image}
                alt=''
                className='categoryUploadImg'
                name='image'
              />
              <label for='file'>
                <Publish />
              </label>
              <input
                type='file'
                id='file'
                style={{ display: "none" }}
                onChange={handleChangeImage}
              />
            </div>
          </div>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message='Category Updated'
        action={closeSnackbarButton}
      />
    </div>
  )
}
